"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var AuthDefaultLocalStorageIo = __importStar(require("./AuthDefaultLocalStorageIo"));
var get_1 = require("../services/user/get");
var types_1 = require("../types");
var AAuth = /** @class */ (function () {
    function AAuth() {
        this.anonymousToken = undefined;
        this.user = undefined;
        this.shouldValidateAnonymous = false;
        this.authLocalStorageIo = AuthDefaultLocalStorageIo;
    }
    AAuth.prototype.init = function (newApiToken, shouldValidateAnonymous, authLocalStorageIo) {
        if (shouldValidateAnonymous === void 0) { shouldValidateAnonymous = false; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (!this.initPromise) {
                    this.initPromise = (function () { return __awaiter(_this, void 0, void 0, function () {
                        var _a, e_1;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    this.apiToken = newApiToken;
                                    this.shouldValidateAnonymous = shouldValidateAnonymous;
                                    if (authLocalStorageIo) {
                                        this.authLocalStorageIo = authLocalStorageIo;
                                    }
                                    _b.label = 1;
                                case 1:
                                    _b.trys.push([1, 8, , 9]);
                                    // 1. Local storage auth
                                    return [4 /*yield*/, this.refreshFromLocalStorage()
                                        // 1.5 eventually force auth anonymous users in SSO before check
                                        // used to migrate replay anonymous accounts to SSO
                                    ];
                                case 2:
                                    // 1. Local storage auth
                                    _b.sent();
                                    _a = this.accessToken;
                                    if (!_a) return [3 /*break*/, 4];
                                    return [4 /*yield*/, this.authLocalStorageIo.shouldForceSsoLoginAccessToken(this.accessToken)];
                                case 3:
                                    _a = (_b.sent());
                                    _b.label = 4;
                                case 4:
                                    if (!_a) return [3 /*break*/, 6];
                                    return [4 /*yield*/, this.setAuthInSSO(this.accessToken)];
                                case 5:
                                    _b.sent();
                                    _b.label = 6;
                                case 6: 
                                // 2. SSO Auth
                                return [4 /*yield*/, this.refreshFromSSO()];
                                case 7:
                                    // 2. SSO Auth
                                    _b.sent();
                                    return [3 /*break*/, 9];
                                case 8:
                                    e_1 = _b.sent();
                                    this.clearAuth('SSO');
                                    return [3 /*break*/, 9];
                                case 9: return [2 /*return*/, this];
                            }
                        });
                    }); })();
                }
                else if (this.lastestDispatchedAuthEvent) {
                    this.dispatchAuthEvent(__assign(__assign({}, this.lastestDispatchedAuthEvent), { authPayload: __assign(__assign({}, this.lastestDispatchedAuthEvent.authPayload), { 
                            // User data might have been changed since the last event
                            user: this.user, accessToken: this.accessToken }) }));
                }
                return [2 /*return*/, this.initPromise];
            });
        });
    };
    AAuth.prototype.refreshFromLocalStorage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var lsUser;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAuthInLocalStorageOnce()];
                    case 1:
                        lsUser = _a.sent();
                        if (lsUser.accessToken) {
                            // user may not be set in localStorage
                            this.setAuth('LOCAL', lsUser);
                        }
                        else {
                            // maybe we dont logout user before SSO check
                            this.clearAuth('LOCAL');
                        }
                        return [2 /*return*/, this];
                }
            });
        });
    };
    AAuth.prototype.refreshFromSSO = function () {
        return __awaiter(this, void 0, void 0, function () {
            var ssoUser;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAuthInSSOOnce()];
                    case 1:
                        ssoUser = _a.sent();
                        if (ssoUser.accessToken && ssoUser.user) {
                            this.setAuth('SSO', ssoUser);
                        }
                        else {
                            this.clearAuth('SSO');
                        }
                        return [2 /*return*/, this];
                }
            });
        });
    };
    AAuth.prototype.setAuth = function (authEventEnv, authPayload) {
        this.user = authPayload.user;
        this.accessToken = authPayload.accessToken;
        if (authEventEnv !== 'LOCAL') {
            this.authLocalStorageIo.write(authPayload);
        }
        this.dispatchAuthEvent({
            name: 'MONASDK_LOGIN',
            kind: "".concat(authEventEnv, "_MONASDK_LOGIN"),
            authPayload: authPayload,
        });
        return this;
    };
    AAuth.prototype.clearAuth = function (authEventEnv) {
        if (authEventEnv === void 0) { authEventEnv = 'SSO'; }
        this.accessToken = undefined;
        this.authLocalStorageIo.clear();
        this.dispatchAuthEvent({
            name: 'MONASDK_LOGOUT',
            kind: "".concat(authEventEnv, "_MONASDK_LOGOUT"),
            authPayload: {},
        });
        return this;
    };
    AAuth.prototype.getUserFromAccessToken = function (accessToken) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.isAnonymousAccessToken(accessToken)) {
                    return [2 /*return*/, Promise.resolve(types_1.defaultAnonymousUser)];
                }
                else {
                    return [2 /*return*/, (0, get_1.getWithAccessToken)(accessToken)];
                }
                return [2 /*return*/];
            });
        });
    };
    AAuth.prototype.dispatchAuthEvent = function (authEvent) {
        var event = new CustomEvent(authEvent.name, {
            detail: __assign({}, authEvent),
            cancelable: false,
        });
        this.lastestDispatchedAuthEvent = authEvent;
        document.dispatchEvent(event);
        return this;
    };
    AAuth.prototype.getAuthInLocalStorageOnce = function () {
        return __awaiter(this, void 0, void 0, function () {
            var lsUser, _a, _b, _c;
            var _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        lsUser = this.authLocalStorageIo.read();
                        if (!lsUser.accessToken) return [3 /*break*/, 4];
                        _b = [__assign({}, lsUser)];
                        _d = {};
                        if (!lsUser.user) return [3 /*break*/, 1];
                        _c = lsUser.user;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.getUserFromAccessToken(lsUser.accessToken)];
                    case 2:
                        _c = (_e.sent());
                        _e.label = 3;
                    case 3:
                        _a = __assign.apply(void 0, _b.concat([(_d.user = _c, _d)]));
                        return [3 /*break*/, 5];
                    case 4:
                        _a = {};
                        _e.label = 5;
                    case 5: return [2 /*return*/, _a];
                }
            });
        });
    };
    AAuth.prototype.getAuthInSSOOnce = function () {
        return this.getAuthInSSO();
    };
    AAuth.prototype.isAnonymousAccessToken = function (accessToken) {
        return accessToken.startsWith('anonymous_');
    };
    return AAuth;
}());
exports.default = AAuth;
